export const moduleName = 'featureFlags';
